/**
 * Quiz staleness — pure helper (Phase Q3, admin review).
 *
 * A draft/approved quiz is "stale" when the transcript it was generated from has
 * since changed. We detect that by comparing the hash captured at generation
 * time (`training_artifact_quizzes.source_transcript_hash`) with the transcript's
 * CURRENT hash (`training_artifact_transcripts.transcript_hash`).
 *
 * NOTE: `transcript_hash` is not yet populated at transcript-write time (that is
 * Phase 2 of the ingestion-automation design — a pgcrypto BEFORE trigger). Until
 * then both hashes are typically null and this returns 'unknown'. The logic is
 * written now so the admin review UI lights up automatically once Phase 2 lands,
 * with no UI change. It NEVER triggers regeneration on its own.
 */
export type QuizStaleState = 'stale' | 'current' | 'unknown';

export function computeQuizStale(
  sourceHash: string | null | undefined,
  currentHash: string | null | undefined,
): QuizStaleState {
  if (!sourceHash || !currentHash) return 'unknown';
  return sourceHash === currentHash ? 'current' : 'stale';
}
